module.exports = __webpack_public_path__ + "img/xarani.376a5df1.png";